import { API_LOGS, API_TALABAT } from 'utils/constants'
import Api from './axiosInstance'
import { CustomObject } from 'types/common'

type LogCommon = {
  limit: number
  page: number
  filters?: CustomObject
}

//  To get all ERP logs from server

export const fetchErpLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.ERP_LOGS}?${params.toString()}` })
}

export const fetchSapLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.SAP_LOGS}?${params.toString()}` })
}

export const downloadSapLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.SAP_LOGS_DOWNLOAD, params: filters })
}

export const fetchAdminAuditLogs = ({
  limit,
  page,
  filters = {},
}: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.ADMIN_AUDIT_LOGS}?${params.toString()}` })
}

export const downloadAdminAuditLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.ADMIN_AUDIT_LOGS_DOWNLOAD, params: filters })
}

// To get all ERP logs from server
export const downloadErpLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.ERP_LOGS_DOWNLOAD, params: filters })
}

//  To get all POS logs from server
export const fetchPosLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.POS_LOGS}?${params.toString()}` })
}

// To get all ERP logs from server
export const downloadPosLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.POS_LOGS_DOWNLOAD, params: filters })
}

// To get all FTP logs from server
export const fetchFtpLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.FTP_LOGS}?${params.toString()}` })
}

// To get all ERP logs from server
export const downloadFtpLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.FTP_LOGS_DOWNLOAD, params: filters })
}

// To get all Import logs from server
export const fetchImportLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.IMPORTS_LOGS}?${params.toString()}` })
}

// To get all POS logs from server
export const fetchOrdersLogs = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.ORDERS_LOGS}?${searchParams.toString()}`,
  })
}

// To get all Reconciliation logs from server
export const fetchReconciliationLogs = ({
  limit,
  page,
  filters = {},
}: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({
    url: `${API_LOGS.RECONCILIATION_LOGS}?${params.toString()}`,
  })
}

// To get all Talon logs from server
export const fetchTalonLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.TALON_LOGS}?${params.toString()}` })
}

export const downloadTalonLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.TALON_LOGS_DOWNLOAD, params: filters })
}

// To get all Import logs from server
export const downloadImportLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.IMPORTS_LOGS_DOWNLOAD, params: filters })
}

// To get all Orders logs from server
export const downloadOrdersLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.ORDERS_LOGS_DOWNLOAD, params: filters })
}

// To get all Orders logs from server
export const downloadReconciliationLogs = (filters?: CustomObject) => {
  return Api.get({
    url: API_LOGS.RECONCILIATION_LOGS_DOWNLOAD,
    params: filters,
  })
}

// To get all Export logs from server
export const fetchExportLogs = ({ limit, page, filters = {} }: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.EXPORT_LOGS}?${params.toString()}` })
}

// To get all Export logs from server
export const downloadExportLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.EXPORT_LOGS_DOWNLOAD, params: filters })
}

// To get all Aggregator API Logs from server
export const fetchAggregatorApiLogs = ({
  limit,
  page,
  filters = {},
}: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.AGGREGATOR_LOGS}?${params.toString()}` })
}

// To get all Aggregator API Logs from server
export const downloadAggregatorApiLog = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.AGGREGATOR_LOGS_DOWNLOAD, params: filters })
}

export const downloadSingleLogFile = (value: string) => {
  return Api.get({ url: value })
}

export const fetchDeliverooSyncLogs = ({
  limit,
  page,
  filters = {},
}: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({
    url: `${API_LOGS.DELIVEROO_SYNC_LOGS}?${params.toString()}`,
  })
}

export const downloadDeliverooSyncLogs = (filters?: CustomObject) => {
  return Api.get({
    url: API_LOGS.DELIVEROO_SYNC_LOGS_DOWNLOAD,
    params: filters,
  })
}

export const fetchTalabatSyncLogs = ({
  limit,
  page,
  filters = {},
}: LogCommon) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...filters,
  })

  return Api.get({ url: `${API_LOGS.TALABAT_LOGS}?${params.toString()}` })
}

export const downloadTalabatLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.TALABAT_LOGS_DOWNLOAD, params: filters })
}

export const triggerPromotionJobPoll = () => {
  return Api.post({ url: API_TALABAT.POLL_PROMOTION })
}

export const fetchPowerBiSyncLogs = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.POWER_BI_SYNC_LOGS}?${searchParams.toString()}`,
  })
}

export const downloadPowerBiSyncLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.POWER_BI_SYNC_LOGS_DOWNLOAD, params: filters })
}

export const fetchPowerBiSyncLogDetail = (id: string) => {
  return Api.get({ url: `${API_LOGS.POWER_BI_SYNC_LOGS}/${id}` })
}

export const fetchKdsSyncLogs = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.KDS_SYNC_LOGS}?${searchParams.toString()}`,
  })
}

export const downloadKdsSyncLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.KDS_SYNC_LOGS_DOWNLOAD, params: filters })
}

export const fetchKdsSyncLogDetail = (id: string) => {
  return Api.get({ url: `${API_LOGS.KDS_SYNC_LOGS}/${id}` })
}

export const fetchLastMileLogs = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.LAST_MILE_LOGS}?${searchParams.toString()}`,
  })
}

export const downloadLastMileLogs = (filters?: CustomObject) => {
  return Api.get({ url: API_LOGS.LAST_MILE_LOGS_DOWNLOAD, params: filters })
}

export const fetchCatalogueActionLogs = (params: {
  limit?: number | string
  page?: number | string
  operationType?: string
  status?: string
  startDate?: string
  endDate?: string
}) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.CATALOGUE_ACTION_LOGS}?${searchParams.toString()}`,
  })
}

export const downloadCatalogueActionLogs = (filters?: CustomObject) => {
  return Api.get({
    url: API_LOGS.CATALOGUE_ACTION_LOGS_DOWNLOAD,
    params: filters,
  })
}

export const fetchGenericLogs = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return Api.get({
    url: `${API_LOGS.GENERIC_LOGS}?${searchParams.toString()}`,
  })
}
